/**
 * `ops` translations, for every locale -- operations (trips' stage and reject,
 * requests' rejected-by and resubmit, activity-fund month grouping). The `trips` /
 * `requests` sections of `sales.ts` keep their own keys.
 */
export const operations = {
  mn: {
    ops: {
      trips: {
        stage: 'Шат',
        stageAwaitingApproval: 'Зөвшөөрөл хүлээж буй',
        stageReadyToPay: 'Төлөхөд бэлэн',
        stagePaid: 'Төлсөн',
        stageRejected: 'Татгалзсан',
        reject: 'Татгалзах',
        rejectReason: 'Татгалзсан шалтгаан',
        rejectConfirm: 'Татгалзах',
        rejected: 'Татгалзлаа',
        rejectedBecause: 'Татгалзсан: {{reason}}',
        resubmitHint: 'Хадгалахад аялал дахин зөвшөөрөл хүлээх төлөвт орно.',
        totalDaysDerived: 'Огнооноос тооцоолно',
        normFromCountry: 'Улсаас тогтооно',
      },
      requests: {
        rejectedBy: 'Татгалзсан',
        asStandInFor: '{{name}}-ийг орлон',
        selfApproved: 'Өөрөө баталсан',
        resubmitHint: 'Хадгалахад хүсэлт дахин зөвшөөрөл хүлээх төлөвт орно.',
        send: 'Явуулсан гэж тэмдэглэх',
        sentToast: 'Явуулсан гэж тэмдэглэлээ',
        sendFailed: 'Явуулсан гэж тэмдэглэж чадсангүй: {{reason}}',
        sentBy: 'Явуулсан',
        sentBeforeApproval: 'Зөвшөөрөлгүй явуулсан',
        signatures: 'Гарын үсэг',
        signaturesCount: '2-оос {{count}}',
        firstSignature: 'Эхний гарын үсэг: {{name}}',
      },
      activity: {
        allMonths: 'Бүх сар',
        name: 'Арга хэмжээний нэр',
        nameRequired: 'Арга хэмжээний нэрийг бөглөнө үү',
        when: 'Хэзээ',
        earlierFields: 'Өмнө бөглөсөн мөрийн {{activity}} ба {{when}} (зөвхөн харах):',
        month: 'Сар',
      },
    },
  },
  en: {
    ops: {
      trips: {
        stage: 'Stage',
        stageAwaitingApproval: 'Awaiting approval',
        stageReadyToPay: 'Ready to pay',
        stagePaid: 'Paid',
        stageRejected: 'Rejected',
        reject: 'Reject',
        rejectReason: 'Reason for rejecting',
        rejectConfirm: 'Reject trip',
        rejected: 'Trip rejected',
        rejectedBecause: 'Rejected: {{reason}}',
        resubmitHint: 'Saving sends this trip back for approval.',
        totalDaysDerived: 'Counted from the dates',
        normFromCountry: 'Set from the country',
      },
      requests: {
        rejectedBy: 'Rejected by',
        asStandInFor: 'as CEO stand-in for {{name}}',
        selfApproved: 'Self-approved',
        resubmitHint: 'Saving sends this request back for approval.',
        send: 'Mark as sent',
        sentToast: 'Marked as sent',
        sendFailed: 'Could not mark as sent: {{reason}}',
        sentBy: 'Sent by',
        sentBeforeApproval: 'Sent before approval',
        signatures: 'Signatures',
        signaturesCount: '{{count}} of 2',
        firstSignature: 'First signature: {{name}}',
      },
      activity: {
        allMonths: 'All months',
        name: 'Activity name',
        nameRequired: 'Enter the activity name',
        when: 'When',
        earlierFields: '{{activity}} and {{when}} entered on earlier lines (read-only):',
        month: 'Month',
      },
    },
  },
  ru: {
    ops: {
      trips: {
        stage: 'Этап',
        stageAwaitingApproval: 'Ожидает утверждения',
        stageReadyToPay: 'Готово к оплате',
        stagePaid: 'Оплачено',
        stageRejected: 'Отклонено',
        reject: 'Отклонить',
        rejectReason: 'Причина отклонения',
        rejectConfirm: 'Отклонить поездку',
        rejected: 'Поездка отклонена',
        rejectedBecause: 'Отклонено: {{reason}}',
        resubmitHint: 'При сохранении поездка снова отправится на утверждение.',
        totalDaysDerived: 'Считается по датам',
        normFromCountry: 'Задаётся по стране',
      },
      requests: {
        rejectedBy: 'Отклонил',
        asStandInFor: 'замещая {{name}}',
        selfApproved: 'Утверждено самим заявителем',
        resubmitHint: 'При сохранении заявка снова отправится на утверждение.',
        send: 'Отметить как отправленное',
        sentToast: 'Отмечено как отправленное',
        sendFailed: 'Не удалось отметить как отправленное: {{reason}}',
        sentBy: 'Отправил',
        sentBeforeApproval: 'Отправлено до утверждения',
        signatures: 'Подписи',
        signaturesCount: '{{count}} из 2',
        firstSignature: 'Первая подпись: {{name}}',
      },
      activity: {
        allMonths: 'Все месяцы',
        name: 'Название мероприятия',
        nameRequired: 'Укажите название мероприятия',
        when: 'Когда',
        earlierFields: '{{activity}} и {{when}}, указанные в прежних строках (только чтение):',
        month: 'Месяц',
      },
    },
  },
}
